import {
  FoodDetailsContent,
  FoodDetailsHeader,
  FoodDetailsInfo,
  StyledFoodDetails,
} from "./styled"
import { BackButton } from "components/Common/BackButton"
import NutrientInformation from "components/foodDetails/share/NutrientInformation"
import Button from "components/Buttons/Button"
import FoodImage from "components/foodDetails/share/FoodImage"
import { useState } from "react"
import ChevronLeftBtn from "components/Icons/ChevronLeftBtn"
import PopConfirm from "components/PopConfirm"
import { IAIScanEdamaFoodOption } from "model/food/types/edama.types"
import useEdamaForm from "features/food/hooks/edamaFood/useEdamaDetailsForm"
import EdamaNameAndPortion from "components/foodDetails/share/EdamaNameAndPortion"
import { isFoodInfoChanged } from "features/food/helper/foodHelper"
import AppStyleCtaBox from "components/Common/AppStyleCtaBox"
import EditNutrientForm from "components/foodDetails/share/EditNutrientForm"
import EditableNutrientInformation from "components/foodDetails/share/EditableNutrientInformation"

interface IFoodDetailsProps {
  onBack: () => void
  food: IAIScanEdamaFoodOption
  onEdit: (food: IAIScanEdamaFoodOption) => void
}

const APIFoodOptionDetails = (props: IFoodDetailsProps) => {
  const { onBack, food, onEdit } = props
  const { onPortionChange, onUnitChange, edama, updateFoodAsManualNutrition } =
    useEdamaForm(food)

  const [displaySection, setDisplaySection] = useState<
    "FOOD_FORM" | "EDIT_NUTRITION_FORM"
  >("FOOD_FORM")

  const [isPopConfirmDiscardOpen, setIsPopConfirmDiscardOpen] = useState(false)

  const [isPortionValid, setIsPortionValid] = useState(true)

  const onPortionChangeHandler = (value: number) => {
    onPortionChange(value)
    setIsPortionValid(true)
  }

  const handleUpdateFood = () => {
    onEdit(edama)
    onBack()
  }

  const handleBack = () => {
    if (isFoodInfoChanged(food, edama)) {
      setIsPopConfirmDiscardOpen(true)
    } else {
      onBack()
    }
  }

  if (displaySection === "EDIT_NUTRITION_FORM") {
    return (
      <EditNutrientForm
        onClose={() => {
          setDisplaySection("FOOD_FORM")
        }}
        meal={edama}
        onSubmit={updateFoodAsManualNutrition}
      />
    )
  }

  return (
    <StyledFoodDetails>
      <PopConfirm
        isOpen={isPopConfirmDiscardOpen}
        title="Unsaved changes?"
        cancelText="Discard"
        confirmText="Save changes"
        onCancel={onBack}
        onConfirm={handleUpdateFood}
        loading={false}
      >
        <p style={{ textAlign: "center" }}>
          You haven't saved your meal yet. Are you sure you want to leave?
        </p>
      </PopConfirm>

      <FoodDetailsContent>
        <FoodImage previewImageUrl={food.previewImageUrl}>
          <FoodDetailsHeader>
            <BackButton onClick={handleBack}>
              <ChevronLeftBtn />
            </BackButton>
          </FoodDetailsHeader>
        </FoodImage>

        <FoodDetailsInfo>
          <EdamaNameAndPortion
            edama={edama}
            unitValue={edama.unit}
            portionValue={edama.portion}
            onPortionChange={onPortionChangeHandler}
            onUnitChange={onUnitChange}
            unitOptions={edama.units}
            setIsPortionValid={setIsPortionValid}
            calories={edama.calorie}
            gram={edama.gram}
          />

          <EditableNutrientInformation
            entry={edama}
            setEditMode={() => setDisplaySection("EDIT_NUTRITION_FORM")}
          />
        </FoodDetailsInfo>
      </FoodDetailsContent>

      <AppStyleCtaBox style={{ marginTop: "auto" }}>
        <Button
          disabled={!isPortionValid}
          style={{ width: "100%" }}
          $type="primary"
          onClick={handleUpdateFood}
        >
          Save
        </Button>
      </AppStyleCtaBox>
    </StyledFoodDetails>
  )
}

export default APIFoodOptionDetails
